export const WORDS = [
  {
    lesson: 1,
    words: [
      { en: "is/am/are", gd: "tha" },
      { en: "isn't/aren't/am not", gd: "chan eil" },
      { en: "me", gd: "mi" },
      { en: "you", gd: "thu" },
      { en: "big", gd: "mòr" },
      { en: "Little", gd: "beag" },
      { en: "tired", gd: "sgìth" },
      { en: "happy", gd: "toilichte" },
      { en: "sad", gd: "brònach" },
      { en: "Anne", gd: "Anna" },
      { en: "John", gd: "Iain" },
      { en: "Calum", gd: "Calum" },
      { en: "Morag", gd: "Mòrag" },
    ],
  },

  {
    lesson: 2,
    words: [
      { en: "is/am/are?", gd: "a bheil?" },
      { en: "isn't/aren't/am not?", gd: "nach eil?" },
      { en: "he", gd: "e" },
      { en: "she", gd: "i" },
      { en: "you (plural, formal)", gd: "sibh" },
      { en: "we", gd: "sinn" },
      { en: "them", gd: "iad" },
      { en: "but", gd: "ach" },
      { en: "and", gd: "agus" },
      { en: "because", gd: "oir" },
    ],
  },

  {
    lesson: 3,
    words: [
      { en: "eating", gd: "ag ithe" },
      { en: "drinking", gd: "ag òl" },
      { en: "reading", gd: "a' leughadh" },
      { en: "writing", gd: "a' sgrìobhadh" },
      { en: "walking", gd: "a' coiseachd" },
      { en: "sleeping", gd: "a' cadal" },
      { en: "cleaning", gd: "a' feitheamh" },
      { en: "water", gd: "a' tuigsinn" },
      { en: "helping", gd: "a' cuideachadh" },
      { en: "cleaning", gd: "a' glanadh" },
      { en: "water", gd: "uisge" },
      { en: "food", gd: "biadh " },
      { en: "book", gd: "leabhar" },
      { en: "house", gd: "taigh" },
      { en: "man/person", gd: "duine" },
      { en: "friend", gd: "caraid" },
      { en: "dog", gd: "cù" },
      { en: "cat", gd: "cat" },
    ],
  },
  {
    lesson: 4,
    words: [
      { en: "something", gd: "rudeigin" },
      { en: "someone", gd: "cuideigin" },
      { en: "doing", gd: "a' dèanamh" },
      { en: "buying", gd: "a' ceannachd" },
      { en: "wanting", gd: "ag iarraidh" },
      { en: "was, were", gd: "bha" },
      { en: "wasn't, weren’t", gd: "cha robh" },
      { en: "was? were?", gd: "an robh?" },
      { en: "wasn't? weren’t?", gd: "nach robh?" },
    ],
  },
  {
    lesson: 5,
    words: [
      { en: `the book`, gd: `an leabhar` },
      { en: `the house`, gd: `an taigh` },
      { en: `the man`, gd: `an duine` },
      { en: `the friend`, gd: `an caraid` },
      { en: `the dog`, gd: `an cù` },
      { en: `the cat`, gd: `an cat` },
      { en: `the water`, gd: `an t-uisge` },
      { en: `the food`, gd: `am biadh` },
    ],
  },
];
